<template>
  <div>
    <div v-if="mock === false">
      <script>
        // https://support.google.com/adsense/answer/9042142?hl=en
        // Setup ad requests to pause until it's known how user interacted with consent solution
        // ;(adsbygoogle = window.adsbygoogle || []).pauseAdRequests = 1
        if (window.adsbygoogle) {
          const cookieControlConsentValue = unescape(
            document.cookie.replace(
              new RegExp(
                '(?:^|.*;\\s*)' +
                  escape('cookie_control_consent').replace(/[-.+*]/g, '\\$&') +
                  '\\s*\\=\\s*((?:[^;](?!;))*[^;]?).*'
              ),
              '$1'
            )
          )

          if (cookieControlConsentValue !== 'true')
            window.adsbygoogle.pauseAdRequests = 1
        }
      </script>
      <!-- Home Page Responsive -->
      <ins
        class="adsbygoogle"
        style="display:block"
        data-ad-client="ca-pub-3171038478246380"
        data-ad-slot="6751708706"
        data-ad-format="auto"
        data-full-width-responsive="true"
      ></ins>
      <script>
        ;(adsbygoogle = window.adsbygoogle || []).push({})
      </script>
    </div>
    <div v-else class="mock">
      <span class="ad-text">
        AD
      </span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    mock: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  }
}
</script>
<style scoped>
.ad-text {
  color: white;
  font-size: 50px;
  font-weight: bold;
}
.mock {
  text-align: center;
  width: 100%;
  height: 150px;
  background-color: #fff9af;
}
</style>
